import { z } from "zod";

export const oidcStatusSchema = z.object({
  enabled: z.boolean(),
  authenticated: z.boolean(),
  expiresAt: z.string().datetime().optional(),
});
export const oidcLogoutSchema = z.object({ logoutUrl: z.string().url() });
